import * as React from 'react';

import {
  relayToMain,
  SocketContext,
  useSetupSocket,
} from '~/renderer/hooks/socket/use-setup-socket';
import { useAnalytics } from '~/renderer/hooks/use-analytics';
import { useDevicesToRetail } from '~/renderer/hooks/use-devices-to-retail';

const SocketEnabled: React.FunctionComponent = ({ children }) => {
  const socket = useSetupSocket();
  return <SocketContext.Provider value={socket}>{children}</SocketContext.Provider>;
};

const SocketRelayed: React.FunctionComponent = ({ children }) => {
  return <SocketContext.Provider value={relayToMain}>{children}</SocketContext.Provider>;
};

const Consumers: React.FC = ({ children }) => {
  useAnalytics();
  useDevicesToRetail();
  return <>{children}</>;
};

const SocketConnection: React.FunctionComponent<{ isEnabled?: boolean; isRelayed?: boolean }> = ({
  isEnabled,
  isRelayed,
  children,
}) => {
  if (isEnabled) {
    return (
      <SocketEnabled>
        <Consumers>{children}</Consumers>
      </SocketEnabled>
    );
  }
  if (isRelayed) {
    return (
      <SocketRelayed>
        <Consumers>{children}</Consumers>
      </SocketRelayed>
    );
  }
  return <>{children}</>;
};

export default SocketConnection;
